import { DateTime } from 'luxon';
import {PtLuxonDate} from '../../../../models/projects/date.models';
import {DateService} from '../../../../services/date/date.service';

export interface DateTimeHydrationResult {
  timeToShow: string;
  selectedLocalDateIso: string;
}

export class JackingDateTimeEntryHelper {
  constructor(private dateService: DateService) {}

  hydrateFromPt(pt: PtLuxonDate | null): DateTimeHydrationResult {
    const dt: any = pt?.dateTime as DateTime;
    if (!dt) {
      return { timeToShow: '', selectedLocalDateIso: '' };
    }

    return {
      selectedLocalDateIso: dt.toISODate ? (dt.toISODate() || '') : '',
      timeToShow: dt.toFormat ? dt.toFormat('HH:mm') : ''
    };
  }

  updateMask(mask: any[], inputTime: string) {
    if (!inputTime) {
      mask[1] = new RegExp('\\d');
      return;
    }
    mask[1] = inputTime.charAt(0) === '2' ? new RegExp('[0-3]') : new RegExp('\\d');
  }

  getBaseDateUtcMidnight(startUtc: DateTime, startOffsetMinutes: number, showDate: boolean, selectedLocalDateIso: string | null): DateTime {
    const startLocal = startUtc.plus({ minutes: startOffsetMinutes || 0 });
    let localIso = startLocal.toISODate();

    if (showDate) {
      localIso = selectedLocalDateIso || localIso;
    }

    const [y, m, d] = localIso.split('-').map(n => Number(n));
    return DateTime.fromObject({ year: y, month: m, day: d, hour: 0, minute: 0 }, { zone: 'utc' });
  }

  async buildLocalPtFromTime(timeToShow: string, baseDateUtcMidnight: DateTime): Promise<PtLuxonDate | null> {
    const allowed = await this.dateService.timeAllowed(timeToShow, baseDateUtcMidnight);
    if (!allowed || !timeToShow) {
      return null;
    }

    const pt = await this.dateService.setPtLuxonDateFromUserEnteredString(timeToShow, baseDateUtcMidnight);

    if ((pt as any)?.offsetNull?.()) { return null; }
    if ((pt as any)?.isLostInTime?.result) { return null; }
    if (!pt?.dateTime) { return null; }

    return pt as any;
  }

  toUtcStored(ptLocal: PtLuxonDate | null): { valueUtc: PtLuxonDate | null; offsetMinutes: number | null } {
    if (!ptLocal?.dateTime) {
      return { valueUtc: null, offsetMinutes: null };
    }

    const utc = new PtLuxonDate();
    utc.dateTime = ptLocal.dateTime.toUTC();

    return {
      valueUtc: utc,
      offsetMinutes: ptLocal.dateTime.offset
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/helpers/jacking-date-time-entry.helper.ts